import { useContext, useEffect } from "react";
import { localidad } from "../../../context/Actions/localidad/localidad";
import { PortalContext } from "../../../context/Provider";
import Dropdown from "../../Genericos/Dropdown/Dropdown";
import InputV1 from "../../Genericos/InputV1/InputV1";
import "./RegistroPcr.css";
const RegistroPcr = ({ onChange, value, onChangeLocalidad }) => {
  const { localidadState, localidadDispatch, registroState } =
    useContext(PortalContext);

  useEffect(() => {
    localidad()(localidadDispatch);
  }, []);

  return (
    <div className="pcr-registroPcr-container">
      <InputV1
        headerStr={"Escriba su nombre y apellido"}
        name="nombre"
        placeholderText="Juan Carlos"
        errorStr="El nombre es requerido"
        checkError={registroState.registro.listError.nombre}
        onChange={onChange}
        isRequired={true}
      />
      <InputV1
        headerStr={"Escriba su domicilio"}
        name="domicilio"
        onChange={onChange}
        errorStr="El domicilio es requerido"
        checkError={registroState.registro.listError.domicilio}
        isRequired={true}
      />
      {localidadState.localidad.data && (
        <div className="ptur-regustroPcr-dropdown">
          <Dropdown
            headerStr="Localidad"
            datos={localidadState.localidad.data}
            onChange={onChangeLocalidad}
            campoCodigo="id"
            descripcion="descripcion"
            placeholder="Busca tu localidad"
            name="localidad"
            valor={value}
            mobileWidth={true}
            // isRequired={true}
          />
        </div>
      )}
      <InputV1
        headerStr={"Ingresá tu email actual"}
        name="email"
        onChange={onChange}
        checkError={registroState.registro.listError.email}
        isRequired={true}
        errorStr="El email es requerido"
      />
      <div className="pcr-registroPcr-txtRecordatorio">
        <span className="rb14m">
          Por este medio le enviaremos el recordatorio del turno y el resultado
          del estudio.
        </span>
      </div>
    </div>
  );
};

export default RegistroPcr;
